import React from 'react';
import PropTypes from 'prop-types';
import _uniq from 'lodash/uniq';

import { SpacerVertical, SwitchCheckbox } from '@klarna/bubble-ui';
import { withTooltip, TOOLTIP_MODES } from 'moet-core';

const SwitchCheckboxWithTooltip = withTooltip(SwitchCheckbox);

export const MultiSelector = ({
  isDisabled: isDisabledGlobally = false,
  onChange = () => null,
  options = [],
  values = [],
}) => {
  const onChangeSelection = (value, isChecked) => {
    if (isChecked) {
      onChange(_uniq([...values, value]));
    } else {
      onChange(values.filter(v => v !== value));
    }
  };

  return (
    <>
      {options.map(({ extraProps = {}, isDisabled = false, label, value, tooltipText }, i) => (
        <React.Fragment key={i}>
          <SwitchCheckboxWithTooltip
            disabled={isDisabled || isDisabledGlobally}
            checked={values.includes(value)}
            onChange={isChecked => onChangeSelection(value, isChecked)}
            tooltipText={tooltipText}
            tooltipMode={TOOLTIP_MODES.ICON}
            {...extraProps}
          >
            {label || value}
          </SwitchCheckboxWithTooltip>
          <SpacerVertical spaceToken="space/150" />
        </React.Fragment>
      ))}
    </>
  );
};

MultiSelector.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      extraProps: PropTypes.object,
      isDisabled: PropTypes.bool,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    }),
  ).isRequired,
  isDisabled: PropTypes.bool,
  values: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
};
